import { IDateTimeFormatter, IDateTimeFormatterBuilder } from "../types/IDateTimeFormatter"
import { DateValue } from "../types/DateValue"
import { UserSettings } from "@cirrus/common/UserSettings"
import { i18nFunc } from "../../i18n/types"

export class StubFormatter implements IDateTimeFormatter {
  userFriendly(date: DateValue, _format: string = "short") {
    return {
      dtFull: (date ? date.toString() : ""),
      dtRelative: (date ? date.toString() : ""),
    }
  }

  withRegionalSettings(date: DateValue) {
    return {
      dtFull: (date ? date.toString() : ""),
      dtRelative: (date ? date.toString() : ""),
    }
  }

  formatWithTimezone = ({ date }) => date.toString()
}

export class StubFormatterBuilder implements IDateTimeFormatterBuilder {
  build(i18n: i18nFunc, userSettings: UserSettings): IDateTimeFormatter {
    return new StubFormatter()
  }
}